module.exports = __webpack_public_path__ + "static/media/mars-awakens-7.3d67c650.jpg";